import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { setDropDownArray } from "../../../redux/dropdownSlice";
import { updateUserState } from "../../../redux/userSlice";

export default (listType)=> {
    const userReducer = useSelector((state) => state.persistedReducers.userReducer);
    const dropdownReducer = useSelector((state) => state.persistedReducers.dropdownReducer);
    const dispatch = useDispatch();
  //  const {listType, counts = false, combinedArray} = props;

    const statusCheckHandler = (currentIndex) => {
        var tempArr = []
        if (currentIndex == 0) {                                //when user checks the view all, it checks whole list
            tempArr = dropdownReducer[listType]?.map((status, index) => {
                if(index == 0) {
                    return { ...status, checked: true }
                } else {
                    return { ...status, checked: false }
                }
            })
        } else {
            tempArr = dropdownReducer[listType]?.map((status, index) => {
                if (index == 0) {                               // when user unchecks any list item, it unchecks the view all
                    return { ...status, checked: (tempArr.filter((type) => type.checked == true)?.length + 1 == tempArr?.length) };
                } else if (index == currentIndex) {
                    if (status.checked == false || dropdownReducer[listType]?.filter((type) => type.checked == true)?.length > 1) {
                        // when user tries to uncheck the only checked list item, it does not allow
                        return { ...status, checked: !status.checked }
                    } else {
                        return status
                    }
                } else {
                    return status
                }
            })
            // when use selects all the list item, it also selects the view all
           // tempArr[0].checked = (tempArr.filter((type) => type.checked == true)?.length + 1 == tempArr?.length);
        }
        dispatch(setDropDownArray({ [listType]: tempArr }))
        onFilterChange(tempArr)
    }
    const onFilterChange = (types) => {
        // const eventsToFilter = listType == "status_type"? userReducer.type_filtered_events : userReducer.status_filtered_events
        const filteredEventsKey = listType == "status_type"? "status_filtered_events" : "type_filtered_events"
        let tempArr = []
        types?.map((type) => {
            if((type.id == 0) && type.checked == true) {
                tempArr = userReducer.events
            } else if (type.checked == true) {
                if(listType == "status_type"){
                    tempArr = [...tempArr, ...userReducer.events.filter((event) => event.status_type_order == type.order)]
                } else {
                    tempArr = [...tempArr, ...userReducer.events.filter((event) => event.event_type == type.value)]
                }
                
            }
        })
        dispatch(updateUserState({ [filteredEventsKey]: tempArr }))

        let combinedFilter = [];
        if(listType == "status_type") {
            tempArr?.map((statusEvent)=> {
                combinedFilter = [...combinedFilter, ...userReducer.type_filtered_events?.filter((typeEvent)=> statusEvent.id == typeEvent.id)];
            })
        } else {
            tempArr?.map((typeEvent)=> {
                combinedFilter = [...combinedFilter, ...userReducer.status_filtered_events?.filter((statusEvent)=> typeEvent.id == statusEvent.id)];
            })
        }
        dispatch(updateUserState({ combined_filter: combinedFilter }))
    }

    const eventCountByStatus = (order) => {
        let eventArr = userReducer.events.filter((event) => event.status_type_order == order)
        return (order == 0 ? userReducer.events.length : eventArr.length)
    }

    useEffect(()=> {
        dropdownReducer[listType]?.map((status, index)=> {
           if (status.checked == true ){
            statusCheckHandler(index)
           }
        })

    },[userReducer.events])

    return {eventCountByStatus, statusCheckHandler}
}